import React from 'react';

import { Job } from '@libs/graphql-types';

import { BayerLocationCodes } from './BayerLocationCodes';
import { DefaultLocationCodes } from './DefaultLocationCodes';

interface LocationCodesProps {
  job: Job;
  showOnlyRequired?: boolean;
}

/**
 * Component that renders different Location Code forms based on job source
 * Currently supports:
 * - Bayer: Custom location code form for Bayer jobs
 * - Default: Standard location code form for all other job sources
 */
export const LocationCodes: React.FC<LocationCodesProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  const jobSource = job?.striive_job?.source;

  switch (jobSource) {
    case 'Bayer':
      return (
        <BayerLocationCodes job={job} showOnlyRequired={showOnlyRequired} />
      );
    case 'HeadFirst':
    default:
      return (
        <DefaultLocationCodes job={job} showOnlyRequired={showOnlyRequired} />
      );
  }
};
